if (!customElements.get('pdp-sticky-add-to-cart')) {
  customElements.define(
    'pdp-sticky-add-to-cart',
    class PdpStickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.sourceButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('.pdp-sticky-atc__button');
        this.label = this.querySelector('.pdp-sticky-atc__label');
        this.spinner = this.querySelector('.loading__spinner');
        this.image = this.querySelector('.pdp-sticky-atc__image img');
        this.price = this.querySelector('.pdp-sticky-atc__price');

        if (!this.sourceButton || !this.button) {
          this.hidden = true;
          return;
        }

        this.handleClick = this.handleClick.bind(this);
        this.button.addEventListener('click', this.handleClick);
        this.setupVisibilityObserver();

        this.sourceObserver = new MutationObserver(() => this.syncFromSource());
        this.sourceObserver.observe(this.sourceButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== String(this.sectionId)) return;

          const nextImage = data.html?.querySelector('.pdp-sticky-atc__image img');
          const nextPrice = data.html?.querySelector('.pdp-sticky-atc__price');

          if (nextImage && this.image) {
            ['src', 'srcset', 'sizes', 'alt', 'width', 'height'].forEach((attribute) => {
              const value = nextImage.getAttribute(attribute);
              if (value !== null) this.image.setAttribute(attribute, value);
            });
          }

          if (nextPrice && this.price) {
            this.price.innerHTML = nextPrice.innerHTML;
          }
        });

        this.syncFromSource();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        this.visibilityObserver?.disconnect();
        this.sourceObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      handleClick() {
        const isDisabled =
          this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';

        if (!isDisabled) {
          this.sourceButton.click();
        }
      }

      syncFromSource() {
        const sourceLabel = Array.from(this.sourceButton.children).find(
          (child) => child.tagName === 'SPAN' && !child.classList.contains('loading__spinner')
        );
        const isDisabled =
          this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
        const isLoading = this.sourceButton.classList.contains('loading');

        if (this.label) {
          if (isLoading) {
            this.label.textContent = 'ADDING';
          } else if (isDisabled) {
            this.label.textContent = sourceLabel?.textContent.trim() || 'Coming soon';
          } else {
            this.label.textContent = this.dataset.availableLabel || 'Add to cart';
          }
        }

        this.button.disabled = isDisabled;
        this.button.classList.toggle('loading', isLoading);
        this.spinner?.classList.add('hidden');
      }

      setupVisibilityObserver() {
        const revealLead = Number(this.dataset.revealLead);
        const lead = Number.isFinite(revealLead) ? revealLead : 120;

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const shouldShow = !entry.isIntersecting;

            this.classList.toggle('is-visible', shouldShow);
            this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
            this.button.tabIndex = shouldShow ? 0 : -1;
          },
          {
            threshold: 0,
            rootMargin: `-${lead}px 0px 0px 0px`,
          }
        );

        this.visibilityObserver.observe(this.sourceButton);
      }
    }
  );
}
